{
	"invalid": "No válido",
	"offline": "offline",
	"online": "online"
}
